import React from "react";
import skill from "./icons/skill.png";
import education from "./icons/educationIcon.png";
import internship from "./icons/internshipIcon.png";
import expereince from "./icons/expereinceIcon.png";
import "./resume.css";
export default function Resume() {
  return (
    <>
      <section className="resumeContainer">
        <div className="resumeTitle">
          <h1>Resume</h1>
          <div>
            <hr />
          </div>
        </div>
        <div className="experienceSection">
          <div className="experienceItem">
            <div className="experienceIcon">
              <img src={expereince} alt="experience icon" />
              <h2 className="experienceLabel">Experience</h2>
            </div>
            <div className="experienceDetails">
              <span>Software Engineer - Full Time</span>
              <div className="experienceHeader">
                <p>
                  <a
                    href="https://www.linkedin.com/company/instacodigo"
                    target="_blank"
                  >
                    InstaCódigo
                  </a>
                </p>
                <span>Mar 2024 - Aug 2024</span>
              </div>
            </div>
            <div className="workDetails">
              <li>
                Collaborated with cross-functional teams to design, develop, and
                implement high-quality Python solutions.
              </li>
              <li>
                Worked with Django and GraphQL on day-to-day tasks, including
                integrating payment gateways and enhancing user authentication.
              </li>
              <li>
                Upgraded legacy code to the latest Python and Django versions.
              </li>
              <li> Implemented Law firm ERP system using Odoo.</li>
            </div>
          </div>
        </div>
        <div className="resumeSection">
          <div className="educationItem">
            <div className="educationIcon">
              <img src={education} alt="education icon" />
              <h2 className="educationLabel">Education</h2>
            </div>
            <div className="educationDetails">
              <span>2016 - 2021</span>
              <p>B.Sc of Computer Engineering</p>
              <p>Computer Engineering Department</p>
              <p>Shoubra Faculty of Engineering, Benha University</p>
            </div>
          </div>
          <div className="internshipsItem">
            <div className="internshipsIcon">
              <img src={internship} alt="internship icon" />
              <h2 className="internshipLabel">Internships</h2>
            </div>
            <div className="internshipsDetails">
              <span>Jul 2023 - Nov 2023</span>
              <p>Intensive Training Program (ITP)</p>
              <p>Full-stack Web Development using Python</p>
              <p>Information Technology Institute (ITI)</p>
            </div>
          </div>
        </div>
        <div className="skillsParentContainer">
          <div className="skillsIcon">
            <img src={skill} alt="skills" />
            <h2 className="skillsLabel">Skills</h2>
          </div>
          <div className="skillsContainer">
            <div className="skillSection">
              <h3>Languages and Libraries</h3>
              <div className="skills">
                <span>Python</span>
                <span>React</span>
                <span>JavaScript</span>
                <span>TypeScript</span>
                <span>jQuery</span>
                <span>MUI</span>
                <span>SCSS</span>
                <span>HTML</span>
                <span>CSS</span>
              </div>
            </div>
            <div className="skillSection">
              <div>
                <h3>Frameworks and Databases</h3>
                <div className="skills">
                  <span>Django</span>
                  <span>Django REST</span>
                  <span>Flask</span>
                  <span>GraphQL</span>
                  <span>SQL</span>
                  <span>PostgreSQL</span>
                  <span>Tailwind</span>
                  <span>Bootstrap</span>
                </div>
              </div>
            </div>
            <div className="skillSection">
              <div>
                <h3>Other</h3>
                <div className="skills">
                  <span>Odoo</span>
                  <span>Linux</span>
                  <span>Docker</span>
                  <span>Git</span>
                  <span>Shell Scripting</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
